import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const adGuard = defineConnector({
  identifier: "adGuard",
  name: "AdGuard Home",
  tagLine: "DNS filtering and network protection",
  logo,
  protocol: "http",
  tags: ["security", "it"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(`${instanceUrl || "https://adguard.example.com"}/control`),
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Use your AdGuard Home admin credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open your AdGuard Home admin UI, then enter that same URL, username, and password below.",
        },
      ],
    },
    {
      title: "Enter your AdGuard Home details",
      items: [
        {
          kind: "url",
          label: "AdGuard Home URL",
          placeholder: "https://adguard.example.com",
          required: true,
          helperText: "Enter the URL you use for the AdGuard Home admin UI.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://adguard.example.com"}/control/status`,
  },
});
